import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'BREAKFAST',
  analyticsName: 'Breakfast included',
  queryKey: 'f_breakfast',
  type: FILTER_TYPES.BOOLEAN,
  bucketify: (hotel) => {
    const boardCode = hotel?.boardCode;

    if (
      boardCode === 'B' ||
      boardCode === 'BB' ||
      boardCode === 'EB' ||
      boardCode === 'A' ||
      boardCode === 'C' ||
      boardCode === 'E' ||
      boardCode === 'U'
    ) {
      return {
        bucketId: FILTER_TYPES.BINARY_BUCKET.TRUE,
        bucketName: 'breakfastNoCharge',
      };
    }

    return {
      bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
      bucketName: 'breakfastNoCharge',
    };
  },
  toQuery: ({ value }) => {
    return value ? 1 : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue,
    };
  },
}));
